export const FETCH_COMPANIES = 'companyActions/FETCH_COMPANIES';
export const FETCH_COMPANIES_SUCCESS = 'companyActions/FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAILED = 'companyActions/FETCH_COMPANIES_FAILURE';

export const FETCH_GROUPS = 'companyActions/FETCH_GROUPS';
export const FETCH_GROUPS_SUCCESS = 'companyActions/FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILED = 'companyActions/FETCH_GROUPS_FAILURE';

export const CREATE_COMPANY = 'companyActions/CREATE_COMPANY';
export const CREATE_COMPANY_SUCCESS = 'companyActions/CREATE_COMPANY_SUCCESS';
export const CREATE_COMPANY_FAILED = 'companyActions/CREATE_COMPANY_FAILURE';

export const SAVE_COMPANY = 'companyActions/SAVE_COMPANY';
export const SAVE_COMPANY_SUCCESS = 'companyActions/SAVE_COMPANY_SUCCESS';
export const SAVE_COMPANY_FAILED = 'companyActions/SAVE_COMPANY_FAILURE';

export const UPDATE_COMPANY = 'companyActions/UPDATE_COMPANY';
export const UPDATE_COMPANY_SUCCESS = 'companyActions/UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAILED = 'companyActions/UPDATE_COMPANY_FAILURE';
export const UPDATE_COMPANY_EDIT = 'companyActions/UPDATE_COMPANY_EDIT';
export const UPDATE_PARTNER = 'companyActions/UPDATE_PARTNER';

export const DELETE_COMPANY = 'companyActions/DELETE_COMPANY';
export const DELETE_COMPANY_SUCCESS = 'companyActions/DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_FAILED = 'companyActions/DELETE_COMPANY_FAILURE';

export const UPDATE_STATUS = 'companyActions/UPDATE_STATUS';

export const FETCH_COMPANY = 'companyActions/FETCH_COMPANY';
export const FETCH_COMPANY_SUCCESS = 'companyActions/FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_FAILED = 'companyActions/FETCH_COMPANY_FAILURE';

export const FETCH_ABOUT = 'companyActions/FETCH_ABOUT';
export const FETCH_ABOUT_SUCCESS = 'companyActions/FETCH_ABOUT_SUCCESS';
export const FETCH_ABOUT_FAILED = 'companyActions/FETCH_ABOUT_FAILURE';

export const LINK_LOGO = 'companyActions/LINK_LOGO';
export const LINK_LOGO_SUCCESS = 'companyActions/LINK_LOGO_SUCCESS';
export const LINK_LOGO_FAILED = 'companyActions/LINK_LOGO_FAILURE';

export const FETCH_USERS = 'companyActions/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'companyActions/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILED = 'companyActions/FETCH_USERS_FAILURE';

export const CREATE_USER = 'companyActions/CREATE_USER';
export const CREATE_USER_SUCCESS = 'companyActions/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'companyActions/CREATE_USER_FAILURE';

export const FETCH_PAGES = 'companyActions/FETCH_PAGES';
export const FETCH_PAGES_SUCCESS = 'companyActions/FETCH_PAGES_SUCCESS';
export const FETCH_PAGES_FAILED = 'companyActions/FETCH_PAGES_FAILURE';
export const CLEAR_COMPANY = 'companyActions/CLEAR_COMPANY';

export const FETCH_COUNTRIES = 'companyActions/FETCH_COUNTRIES';
export const FETCH_COUNTRIES_SUCCESS = 'companyActions/FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAILED = 'companyActions/FETCH_COUNTRIES_FAILURE';

export function fetchCompanies(filters, clear) {
  return {
    type: FETCH_COMPANIES,
    filters,
    clear,
  };
}

export function fetchCompaniesSuccess(details) {
  return {
    type: FETCH_COMPANIES_SUCCESS,
    details,
  };
}

export function fetchCompaniesFailed(err) {
  return {
    type: FETCH_COMPANIES_FAILED,
    err,
  };
}

export function fetchGroups() {
  return {
    type: FETCH_GROUPS,
  };
}

export function fetchGroupsSuccess(groups) {
  return {
    type: FETCH_GROUPS_SUCCESS,
    groups,
  };
}

export function fetchGroupsFailed(err) {
  return {
    type: FETCH_GROUPS_FAILED,
    err,
  };
}

export function createCompany(details) {
  return {
    type: CREATE_COMPANY,
    details,
  };
}

export function createCompanySuccess(company) {
  return {
    type: CREATE_COMPANY_SUCCESS,
    company,
  };
}

export function createCompanyFailed(err) {
  return {
    type: CREATE_COMPANY_FAILED,
    err,
  };
}

export function saveCompany(details, review) {
  return {
    type: SAVE_COMPANY,
    details,
    review,
  };
}

export function saveCompanySuccess(company, action) {
  return {
    type: SAVE_COMPANY_SUCCESS,
    company,
    action,
  };
}

export function saveCompanyFailed(err) {
  return {
    type: SAVE_COMPANY_FAILED,
    err,
  };
}

export function updatePartner(details) {
  return {
    type: UPDATE_PARTNER,
    details,
  };
}

export function updateCompany(details, review) {
  return {
    type: UPDATE_COMPANY,
    details,
    review,
  };
}

export function updateCompanyEdit(details) {
  return {
    type: UPDATE_COMPANY_EDIT,
    details,
  };
}

export function updateCompanySuccess(company, action) {
  return {
    type: UPDATE_COMPANY_SUCCESS,
    company,
    action,
  };
}

export function updateCompanyFailed(err) {
  return {
    type: UPDATE_COMPANY_FAILED,
    err,
  };
}

export function updateStatus() {
  return {
    type: UPDATE_STATUS,
  };
}

export function getCompanyById(id, status) {
  return {
    type: FETCH_COMPANY,
    id,
    status,
  };
}

export function getCompanyByIdSuccess(company, posts, pageFolders) {
  return {
    type: FETCH_COMPANY_SUCCESS,
    company,
    posts,
    pageFolders,
  };
}

export function getCompanyByIdFailed(err) {
  return {
    type: FETCH_COMPANY_FAILED,
    err,
  };
}

export function fetchAbout(id) {
  return {
    type: FETCH_ABOUT,
    id,
  };
}

export function fetchAboutSuccess(about) {
  return {
    type: FETCH_ABOUT_SUCCESS,
    about,
  };
}

export function fetchAboutFailed(err) {
  return {
    type: FETCH_ABOUT_FAILED,
    err,
  };
}

export function linkLogo(companyId, logoId) {
  return {
    type: LINK_LOGO,
    companyId,
    logoId,
  };
}

export function linkLogoSuccess(details) {
  return {
    type: LINK_LOGO_SUCCESS,
    details,
  };
}

export function linkLogoFailed(err) {
  return {
    type: LINK_LOGO_FAILED,
    err,
  };
}

export function deleteCompany(companyId) {
  return {
    type: DELETE_COMPANY,
    companyId,
  };
}

export function deleteCompanySuccess(company) {
  return {
    type: DELETE_COMPANY_SUCCESS,
    company,
  };
}

export function deleteCompanyFailed(err) {
  return {
    type: DELETE_COMPANY_FAILED,
    err,
  };
}

export function fetchUsers(companyId) {
  return {
    type: FETCH_USERS,
    companyId,
  };
}

export function fetchUsersSuccess(users) {
  return {
    type: FETCH_USERS_SUCCESS,
    users,
  };
}

export function fetchUsersFailed(err) {
  return {
    type: FETCH_USERS_FAILED,
    err,
  };
}

export function createUser(companyId, userDetails) {
  return {
    type: CREATE_USER,
    userDetails,
    companyId,
  };
}

export function createUserSuccess(user) {
  return {
    type: CREATE_USER_SUCCESS,
    user,
  };
}

export function createUserFailed(error) {
  return {
    type: CREATE_USER_FAILED,
    error,
  };
}

export function fetchPages(companyId) {
  return {
    type: FETCH_PAGES,
    companyId,
  };
}

export function fetchPagesSuccess(pageFolders) {
  return {
    type: FETCH_PAGES_SUCCESS,
    pageFolders,
  };
}

export function fetchPagesFailed(err) {
  return {
    type: FETCH_PAGES_FAILED,
    err,
  };
}

export function clearCompany() {
  return {
    type: CLEAR_COMPANY,
  };
}

export function fetchCountries() {
  return {
    type: FETCH_COUNTRIES,
  };
}

export function fetchCountriesSuccess(list) {
  return {
    type: FETCH_COUNTRIES_SUCCESS,
    list,
  };
}

export function fetchCountriesFailed(err) {
  return {
    type: FETCH_COUNTRIES_FAILED,
    err,
  };
}
